<template>
  <v-dialog
    v-model="confirmationPopupDelete"
    persistent
    max-width="290"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card>
      <v-card-title class="headline">Delete User?</v-card-title>
      <v-card-text>{{ deleteTitle }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="rounded-pill" text @click="closeDialog">Cancel</v-btn>
        <v-btn
          class="rounded-pill elevation-0"
          color="accent"
          @click="
            confirmationPopupDelete = false
            $emit('confirmDeleteUser')
          "
          >{{ deleteButtonTitle }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RemoveUserDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    deleteTitle: {
      type: String,
      default: '',
    },
    deleteButtonTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      confirmationPopupDelete: false,
    }
  },
  watch: {
    showDialog: function(val) {
      this.confirmationPopupDelete = val
    },
  },
  methods: {
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) {
        this.closeDialog()
      }
    },
    closeDialog() {
      this.confirmationPopupDelete = false
      this.$emit('close-dialog')
    },
  },
}
</script>
